import { FormEvent, Fragment, useEffect, useState } from "react";
import BookingConfirmation from "../../components/bookingTemplate/BookingConfirmation";
import { InputField } from "../../components/input/Input";
import { Modal } from "../../components/modal/Modal";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import BookingDocument from "../../components/bookingTemplate/BookingDocument";
import TrafficCoursePDF from "../../components/bookingTemplate/TrafficCoursePDF";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../index.css";
// import html2pdf from "html2pdf.js";

export type formData = {
  firstName: string;
  lastName: string;
  email: string;
  streetAddress: string;
  postalCode: string;
  city: string;
  bday: string;
  telNumber: string;
  learnerSwissNumber: string;
  voucherCode: string;
  terms: boolean;
};

// export const action = async ({ request }: { request: Request }) => {
//   const formData = await request.formData();
//   const name = formData.get("name") as string;
//   const email = formData.get("email") as string;
//   const message = formData.get("message") as string;

//   if (!name || !email || !message) {
//     return json({ error: "All fields are required." }, { status: 400 });
//   }

//   try {
//     // Send email
//     await sendEmail({
//       to: "recipient@example.com", // Replace with your recipient's email
//       subject: `New message from ${name}`,
//       text: `From: ${name} (${email})\n\n${message}`,
//       html: `<p>From: <strong>${name}</strong> (${email})</p><p>${message}</p>`,
//     });

//     return json({ success: "Email sent successfully!" });
//   } catch (error) {
//     return json(
//       { error: "Failed to send email. Please try again later." },
//       { status: 500 }
//     );
//   }
// };

const RegisterModal = ({
  showModal,
  onToggleModal,
  cardSelectedValues,
  type,
}: {
  showModal: boolean;
  onToggleModal: () => void;
  cardSelectedValues: any;
  type: "vku" | "plus" | null;
}) => {
  const [showInfoModal, setShowInfoModal] = useState(false);
  const onToggleInfoModal = () => setShowInfoModal(!showInfoModal);
  const [pdfBase64, setPdfBase64] = useState(null); // State to store base64

  useEffect(() => {
    // Dynamically load SMTP.js
    const script = document.createElement("script");
    script.src = "https://smtpjs.com/v3/smtp.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  const [formData, setFormData] = useState<formData>({
    firstName: "",
    lastName: "",
    email: "",
    streetAddress: "",
    postalCode: "",
    city: "",
    bday: "",
    telNumber: "",
    learnerSwissNumber: "",
    voucherCode: "",
    terms: false,
  });

  const handleDateChange = (date: Date | null) => {
    setFormData({
      ...formData,
      bday: date?.toLocaleDateString("en-GB") ?? "",
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    const checked =
      type === "checkbox" ? (e.target as HTMLInputElement).checked : undefined;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleGeneratePdf = async () => {
    const element = document.getElementById("emailContent"); // Grab the content to be converted

    const options = {
      margin: 10,
      filename: "booking-confirmation.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 4 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      jsPDFCallback: (pdf: any) => {
        const pdfBase64String = pdf.output("datauristring"); // Convert to Base64

        setPdfBase64(pdfBase64String); // Set the base64 string in state
        return pdfBase64String;
      },
    };
    // const html2pdf = (await import("html2pdf.js")).default;
    // html2pdf.default().from(element).set(options).save();
    // try {
    //   // Generate the PDF and get the Base64 string asynchronously
    //   const pdfBase64String = await new Promise((resolve, reject) => {
    //     html2pdf()
    //       .from(element)
    //       .set(options)
    //       .toPdf()
    //       .get("pdf")
    //       .then((pdf: any) => {
    //         const pdfBase64String = pdf.output("datauristring");
    //         resolve(pdfBase64String); // Resolving the base64 string
    //       })
    //       .catch((error) => reject(error)); // Handle errors in PDF generation
    //   });

    //   return pdfBase64String;
    // } catch (error) {
    //   console.error("Error generating PDF:", error);
    //   return null; // Return null if there was an error generating the PDF
    // }
  };

  const handlePDF = async () => {
    const blob = await pdf(
      <TrafficCoursePDF
        data={formData}
        cardSelectedValues={cardSelectedValues}
        type={type}
      />
    ).toBlob();
    saveAs(blob, "mydocument.pdf");
    return blob;
  };

  const handleSendEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    const formDataValues = new FormData(e.target as HTMLFormElement); // Retrieves all form inputs

    const pdf = await handlePDF();
    const applicantName = formDataValues.get("firstName");
    const applicantSurname = formDataValues.get("lastName");
    const attachmentName = `Fahrschul-kurse_${applicantName}-${applicantSurname}.pdf`;

    const formData = new FormData();
    formData.append(
      "recipient",
      formDataValues.get("email") ?? "kontakt@fahrschul-kurse.ch"
    );
    formData.append(
      "subject",
      "Herzlichen Glueckwunsch zur Anmeldung bei FahrschulKurse"
    );
    formData.append(
      "message",
      "<h3>Ihre Registrierungsanfrage wurde gesendet</h3><p>Siehe beigef&uuml;gtes PDF</p>"
    );
    formData.append(
      "attachment",
      pdf,
      `Fahrschul-kurse_${applicantName}-${applicantSurname}.pdf`
    );

    try {
      // Send the POST request to the PHP backend
      const response = await fetch(
        "https://www.fahrschul-kurse.ch/services/emailservice/sendEmail.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("E-Mail erfolgreich gesendet!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          streetAddress: "",
          postalCode: "",
          city: "",
          bday: "",
          telNumber: "",
          learnerSwissNumber: "",
          voucherCode: "",
          terms: false,
        });
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Fehler beim Senden der E-Mail:", error);
      alert("E-Mail konnte nicht gesendet werden.");
    }

    if (pdf === null) {
      console.error("PDF wurde noch nicht generiert");
      return;
    }
  };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   try {
  //     const response = await fetch("/api/send-email", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(formData),
  //     });

  //     const result = await response.json();
  //     if (response.ok) {
  //       // setStatus("Email sent successfully!");
  //     } else {
  //       // setStatus(result.error || "Failed to send email.");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     //   setStatus("An error occurred while sending the email.");
  //   }
  //   console.log("Form Data Submitted:", formData);
  // };

  const minShowDate = new Date();
  minShowDate.setFullYear(minShowDate.getFullYear() - 80);

  return (
    // <div className="min-h-screen bg-gray-50">
    <div>
      <div className="hidden">
        <BookingConfirmation
          data={formData}
          cardSelectedValues={cardSelectedValues}
          type={type}
        />
      </div>
      <Modal
        modalNumber={7}
        isOpen={showInfoModal}
        onToggleModal={onToggleInfoModal}
        headerText="Lernfahrausweis Nummer"
      >
        <div className="flex justify-center">
          <img
            src={"/assets/images/licenseNR.jpg"}
            alt="Lernfahrausweis Nummer"
            className="h-96 w-96 object-fit"
          />
        </div>
      </Modal>
      <Modal
        modalNumber={6}
        isOpen={showModal}
        showSubmit={formData.terms}
        onToggleModal={onToggleModal}
        handleSubmit={handleSendEmail}
        submitText="Registrieren"
        headerText="Ausfüllen, um sich zu registrieren"
      >
        <div className="mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input className="hidden" />
            <input className="hidden" />
            <InputField
              type="text"
              name="firstName"
              isRequired={true}
              autoComplete="given-name"
              placeholder="Vorname"
              value={formData.firstName}
              onChange={handleChange}
            />
            <InputField
              type="text"
              name="lastName"
              isRequired={true}
              autoComplete="family-name"
              placeholder="Nachname"
              value={formData.lastName}
              onChange={handleChange}
            />
            <InputField
              type="text"
              isRequired={true}
              name="streetAddress"
              autoComplete="street-address"
              placeholder="Straße, Nr"
              value={formData.streetAddress}
              onChange={handleChange}
            />
            <div className="grid grid-cols-2 md:grid-cols-2 gap-2">
              <InputField
                type="text"
                name="postalCode"
                isRequired={true}
                autoComplete="postal-code"
                placeholder="PLZ"
                value={formData.postalCode}
                onChange={handleChange}
              />
              <InputField
                type="text"
                name="city"
                isRequired={true}
                autoComplete="address-level2"
                placeholder="ORT"
                value={formData.city}
                onChange={handleChange}
              />
            </div>
            <InputField
              type="email"
              name="email"
              isRequired={true}
              autoComplete="email"
              placeholder="E-Mail"
              value={formData.email}
              onChange={handleChange}
            />
            {type === "plus" ? (
              <div className="grid grid-cols-2 md:grid-cols-2 gap-2 pb-4">
                <InputField
                  type="tel"
                  name="telNumber"
                  isRequired={true}
                  autoComplete="tel"
                  placeholder="Telefonnummer"
                  value={formData.telNumber}
                  onChange={handleChange}
                />
                <DatePicker
                  id={"bday"}
                  showIcon
                  toggleCalendarOnIconClick
                  isClearable
                  withPortal
                  dropdownMode="select"
                  showYearDropdown
                  showMonthDropdown
                  minDate={minShowDate}
                  maxDate={new Date()}
                  // yearDropdownItemNumber={-50} // Show 15 years in the dropdown
                  // scrollableYearDropdown
                  closeOnScroll={true}
                  name={"bday"}
                  dateFormat={"dd/MM/yyyy"}
                  placeholderText={"Geburtstag"}
                  value={formData.bday}
                  required={true}
                  wrapperClassName="w-full"
                  popperClassName="custom-calendar w-full"
                  popperPlacement="top-end"
                  calendarIconClassName="mt-1 h-full"
                  // portalId="root-portal"
                  onChange={handleDateChange}
                  // calendarClassName="custom-calendar"
                  className="border w-full py-4 h-10 rounded-lg px-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            ) : (
              <InputField
                type="tel"
                name="telNumber"
                isRequired={true}
                autoComplete="tel"
                placeholder="Telefonnummer"
                value={formData.telNumber}
                onChange={handleChange}
              />
            )}
            {/* <div className={`grid grid-cols-1 max-md:grid-cols-2 gap-2`}> */}
            {/* <div className="relative"> */}
          </div>
          {type === "vku" && (
            <div className={`grid grid-cols-2 max-md:grid-cols-2 gap-4 py-4`}>
              <div className="relative">
                <DatePicker
                  id={"bday"}
                  showIcon
                  toggleCalendarOnIconClick
                  isClearable
                  withPortal
                  dropdownMode="select"
                  showYearDropdown
                  showMonthDropdown
                  minDate={minShowDate}
                  maxDate={new Date()}
                  // yearDropdownItemNumber={-50} // Show 15 years in the dropdown
                  // scrollableYearDropdown
                  closeOnScroll={true}
                  name={"bday"}
                  dateFormat={"dd/MM/yyyy"}
                  placeholderText={"Geburtstag (DD-MM-YYYY)"}
                  value={formData.bday}
                  required={true}
                  wrapperClassName="w-full"
                  popperClassName="custom-calendar w-full"
                  popperPlacement="top-end"
                  calendarIconClassName="mt-1 h-full"
                  // portalId="root-portal"
                  onChange={handleDateChange}
                  // calendarClassName="custom-calendar"
                  className="border w-full py-4 h-10 rounded-lg px-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <InputField
                type="text"
                isRequired={true}
                name="learnerSwissNumber"
                autoComplete="learner-schweiz-nummer"
                placeholder="Lernfahrausweis Nr."
                icon={
                  <button
                    type="button"
                    onClick={() => setShowInfoModal(true)}
                    className="text-light-blue font-bold text-xl"
                  >
                    ⓘ
                  </button>
                }
                value={formData.learnerSwissNumber}
                onChange={handleChange}
              />
            </div>
          )}
          <div className={`grid grid-cols-2 pb-4 pr-4`}>
            <InputField
              type="text"
              name="voucherCode"
              placeholder="Gutscheincode (Optional)"
              value={formData.voucherCode}
              onChange={handleChange}
            />
          </div>
          {/* Checkbox */}
          <div className="md:col-span-2 flex items-start space-x-2">
            <input
              id="terms"
              name="terms"
              type="checkbox"
              checked={formData.terms}
              onChange={handleChange}
              className="mt-1 w-4 h-4 border-gray-300 rounded"
            />
            <label htmlFor="terms" className="text-gray-700 text-sm">
              Ich akzeptiere die Allgemeinen Geschäftsbedingungen. Ich habe
              gelesen und Ich habe die Datenschutzerklärung verstanden.
            </label>
          </div>
        </div>
        {/* Register Button */}
      </Modal>
    </div>
  );
};

export default RegisterModal;
